import FIPModel from "../../Models/FIPModel";

const intiState = {
  fips: Array<FIPModel>(),
};

export default function fip(state = intiState, action: any) {
  switch (action.type) {
    case "ADD_FIP":
      return {
        ...state,
        fips: action.payload.fips,
      };

    default:
      return state;
  }
}
